export const API_URL = 'https://api.backupmonkey.io/'
export const SENTRY_DSN = 'https://b10cbd8d509b4fde9ca64eac7aef24d7@sentry.backupmonkey.io/3'
export const ECHOSERVER = 'api.backupmonkey.io'
export const STRIPE_KEY = 'pk_live_KfcJMNaO1ZRv2RDOXFBeLzCg'
export default { API_URL, ECHOSERVER, STRIPE_KEY, SENTRY_DSN }
